import { App } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import CreateSalesReturnForm from "./components/CreateSalesReturnForm";
import { createSalesReturnPayload } from "../../../utils/sales_return";

import {
  createSalesReturn,
  fetchSalesReturnVoucher,
  fetchSalesReturnAccounts,
  fetchDiscountAccounts,
  fetchTaxAccounts,
  fetchTransportAccounts,
  fetchSalesReturnWithDetails,
  updateSalesReturn,
} from "../salesReturnThunks";

import {
  selectSalesReturnVoucher,
  selectVouchersList,
  selectSalesReturnSuccess,
  selectSelectedVoucherDetails,
  selectSalesReturnAccounts,
  selectTaxAccounts,
  selectDiscountAccounts,
  selectTransportAccounts,
} from "../salesReturnSelectors";

import { resetFormData, resetSalesReturnState, resetSalesReturnStatus, setFormField, setIsEditSalesReturn } from "../salesReturnSlice";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";

const SalesReturn = ({ authInfo }) => {
  const dispatch = useDispatch();
  const { message, modal } = App.useApp();
  const navigate = useNavigate();
  const { sale_r_id } = useParams();

  const salesReturnVoucher = useSelector(selectSalesReturnVoucher);
  const vouchersList = useSelector(selectVouchersList);
  const selectedVoucherDetails = useSelector(selectSelectedVoucherDetails);
  const salesReturnSuccess = useSelector(selectSalesReturnSuccess);
  const salesReturnAccounts = useSelector(selectSalesReturnAccounts);
  const salesTaxAccounts = useSelector(selectTaxAccounts);
  const salesDiscountAccounts = useSelector(selectDiscountAccounts);
  const salesTransportAccounts = useSelector(selectTransportAccounts);
  const selectedRecord = useSelector(selectSelectedVoucherDetails);

  const { is_tatmeen_product, parent_sscc_code } = useSelector(
    (state) => state.salesReturn.formData
  );

  // // ============================================
  // // 🚀 COMPLETE TATMEEN VALIDATION FUNCTION
  // // ============================================
  // const validateTatmeen = (itemsList, isTatmeenProduct, parentSsccCode) => {
  //   const errors = [];
  //   const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
  //     authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');;

  //   if (!isTatmeenUAE) {
  //     return { valid: true, errors: [] };
  //   }

  //   // ✅ Only consider items with return_quantity > 0
  //   const itemsWithReturn = itemsList.filter(
  //     item => Number(item.return_quantity || 0) > 0
  //   );

  //   // ============================================
  //   // RULE 1: If Parent SSCC is given, Tatmeen must be enabled
  //   // ============================================
  //   const hasParentSSCC = parentSsccCode && parentSsccCode.trim() !== "";
  //   const hasChildSSCC = itemsWithReturn.some(
  //     item => item.child_sscc_code && item.child_sscc_code.trim() !== ""
  //   );

  //   if (hasParentSSCC && !isTatmeenProduct) {
  //     errors.push({
  //       field: 'parent_sscc_code',
  //       message: 'Parent SSCC Code is provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.'
  //     });
  //   }

  //   // ============================================
  //   // RULE 2: If Child SSCC is given, Tatmeen must be enabled
  //   // ============================================
  //   if (hasChildSSCC && !isTatmeenProduct) {
  //     const itemsWithChildSSCC = itemsWithReturn
  //       .filter(item => item.child_sscc_code && item.child_sscc_code.trim() !== '')
  //       .map(item => item.product || item.item_name || 'Unknown Item')
  //       .join(', ');

  //     errors.push({
  //       field: 'child_sscc_code',
  //       message: `Child SSCC Codes are provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes. Items with Child SSCC: ${itemsWithChildSSCC}`
  //     });
  //   }

  //   // ============================================
  //   // RULE 3: If Tatmeen is enabled, validate ALL requirements
  //   // ============================================
  //   if (isTatmeenProduct) {
  //     // 3a: Parent SSCC is required
  //     if (!hasParentSSCC) {
  //       errors.push({
  //         field: 'parent_sscc_code',
  //         message: 'Tatmeen is enabled but Parent SSCC Code is missing. Please enter the Parent SSCC Code.'
  //       });
  //     }

  //     // 3b: Every item with return_qty > 0 must have batch selected
  //     const itemsWithoutBatch = itemsWithReturn.filter(
  //       item => !item.selected_batch_id
  //     );

  //     if (itemsWithoutBatch.length > 0) {
  //       const itemNames = itemsWithoutBatch
  //         .map(item => item.product || item.item_name || 'Unknown Item')
  //         .join(', ');

  //       errors.push({
  //         field: 'batch_id',
  //         message: `Tatmeen is enabled but the following items are missing Batch selection:\n\n${itemNames}\n\nEach returned item must have a batch selected.`
  //       });
  //     }

  //     // 3c: Every item with return_qty > 0 must have Child SSCC
  //     const itemsWithoutChildSSCC = itemsWithReturn.filter(
  //       item => !item.child_sscc_code || item.child_sscc_code.trim() === ''
  //     );

  //     if (itemsWithoutChildSSCC.length > 0) {
  //       const itemNames = itemsWithoutChildSSCC
  //         .map(item => item.product || item.item_name || 'Unknown Item')
  //         .join(', ');

  //       errors.push({
  //         field: 'child_sscc_code',
  //         message: `Tatmeen is enabled but the following items are missing Child SSCC Code:\n\n${itemNames}\n\nEach returned item must have a Child SSCC Code.`
  //       });
  //     }

  //     // 3d: Child SSCC validation with Parent
  //     const childSSCCs = itemsWithReturn
  //       .map(item => item.child_sscc_code?.trim() || "")
  //       .filter(code => code !== "");

  //     if (childSSCCs.length > 0) {
  //       const distinctChildSSCCs = [...new Set(childSSCCs)];

  //       if (distinctChildSSCCs.length === 1) {
  //         // If all child SSCC are same, parent SSCC should also be the same
  //         const childSSCC = distinctChildSSCCs[0];
  //         if (parentSsccCode.trim() !== childSSCC) {
  //           errors.push({
  //             field: 'parent_sscc_code',
  //             message: `All Child SSCC Codes are "${childSSCC}" but Parent SSCC Code is "${parentSsccCode}".\n\nParent SSCC must match the Child SSCC when all are the same.`
  //           });
  //         }
  //       } else if (distinctChildSSCCs.length > 1) {
  //         // If multiple distinct child SSCC, parent should NOT match any
  //         if (distinctChildSSCCs.includes(parentSsccCode.trim())) {
  //           errors.push({
  //             field: 'parent_sscc_code',
  //             message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSsccCode}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`
  //           });
  //         }
  //       }
  //     }

  //     // ============================================
  //     // RULE 4: Serial validation for items with return_qty > 0
  //     // ============================================
  //     const serialErrors = validateSerialsForTatmeen(itemsWithReturn);
  //     errors.push(...serialErrors);
  //   }

  //   // ============================================
  //   // RULE 5: SSCC provided but Tatmeen NOT enabled (already covered in RULE 1 & 2)
  //   // ============================================
  //   // (Already covered by RULE 1 and RULE 2)

  //   return {
  //     valid: errors.length === 0,
  //     errors: errors
  //   };
  // };
  // // ============================================
  // // 🚀 SERIAL VALIDATION FOR TATMEEN
  // // ============================================
  // const validateSerialsForTatmeen = (itemsWithReturn) => {
  //   const errors = [];
  //   const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
  //     authInfo?.country === "United Arab Emirates";

  //   if (!isTatmeenUAE || !is_tatmeen_product) return errors;

  //   // Collect all serials for cross-item validation
  //   const allSerials = [];
  //   const serialToItemMap = {};

  //   for (const row of itemsWithReturn) {
  //     const serialMode = row.serial_mode || "unit";
  //     const returnQty = Number(row.return_quantity || 0);
  //     const selectedSerials = row.selectedSerials || [];

  //     // ============================================
  //     // UNIT MODE: Selected serials must match return quantity
  //     // ============================================
  //     if (serialMode === "unit") {
  //       // Check if serial count matches return quantity
  //       if (selectedSerials.length !== returnQty) {
  //         errors.push({
  //           field: 'serials',
  //           item: row.product || row.item_name || 'Unknown Item',
  //           message: `"${row.product || row.item_name || 'Unknown Item'}" requires ${returnQty} serial number${returnQty > 1 ? 's' : ''} but ${selectedSerials.length} selected.\n\nPlease select exactly ${returnQty} serial number${returnQty > 1 ? 's' : ''} for this item.`
  //         });
  //       }

  //       // Check for duplicates within the same item
  //       const duplicateWithinItem = selectedSerials.filter(
  //         (s, index) => selectedSerials.indexOf(s) !== index
  //       );

  //       if (duplicateWithinItem.length > 0) {
  //         errors.push({
  //           field: 'serials',
  //           item: row.product || row.item_name || 'Unknown Item',
  //           message: `"${row.product || row.item_name || 'Unknown Item'}" contains duplicate serial numbers within the same item: ${duplicateWithinItem.join(', ')}.\n\nPlease remove duplicate serial numbers.`
  //         });
  //       }

  //       // Store serials for cross-item validation
  //       selectedSerials.forEach(serial => {
  //         if (serial && serial.trim()) {
  //           const trimmedSerial = serial.trim();
  //           allSerials.push(trimmedSerial);
  //           if (!serialToItemMap[trimmedSerial]) {
  //             serialToItemMap[trimmedSerial] = [];
  //           }
  //           serialToItemMap[trimmedSerial].push(row.product || row.item_name || 'Unknown Item');
  //         }
  //       });
  //     }
  //     // ============================================
  //     // BATCH MODE: Exactly 1 serial required
  //     // ============================================
  //     else if (serialMode === "batch") {
  //       // Check if exactly 1 serial is selected
  //       if (selectedSerials.length !== 1) {
  //         errors.push({
  //           field: 'serials',
  //           item: row.product || row.item_name || 'Unknown Item',
  //           message: `"${row.product || row.item_name || 'Unknown Item'}" (Batch Mode) requires exactly 1 serial number but ${selectedSerials.length} selected.\n\nPlease select exactly 1 serial number for this batch item.`
  //         });
  //       }

  //       // Batch mode: return_qty must be either 0 or full quantity
  //       const availableQty = Number(row.available_qty || 0);
  //       if (returnQty !== 0 && returnQty !== availableQty) {
  //         errors.push({
  //           field: 'return_quantity',
  //           item: row.product || row.item_name || 'Unknown Item',
  //           message: `"${row.product || row.item_name || 'Unknown Item'}" is in Batch Mode. Return quantity must be either 0 or ${availableQty}.`
  //         });
  //       }

  //       // Store serial for cross-item validation
  //       const serial = selectedSerials[0];
  //       if (serial && serial.trim()) {
  //         const trimmedSerial = serial.trim();
  //         allSerials.push(trimmedSerial);
  //         if (!serialToItemMap[trimmedSerial]) {
  //           serialToItemMap[trimmedSerial] = [];
  //         }
  //         serialToItemMap[trimmedSerial].push(row.product || row.item_name || 'Unknown Item');
  //       }
  //     }
  //   }

  //   // ============================================
  //   // CROSS-ITEM SERIAL VALIDATION
  //   // Check if any serial appears in more than one item
  //   // ============================================
  //   const serialCount = {};
  //   allSerials.forEach(serial => {
  //     serialCount[serial] = (serialCount[serial] || 0) + 1;
  //   });

  //   const duplicateSerials = Object.keys(serialCount).filter(
  //     serial => serialCount[serial] > 1
  //   );

  //   if (duplicateSerials.length > 0) {
  //     const duplicateDetails = duplicateSerials.map(serial => {
  //       const items = serialToItemMap[serial] || [];
  //       const uniqueItems = [...new Set(items)];
  //       return `Serial "${serial}" appears in: ${uniqueItems.join(', ')}`;
  //     }).join('\n');

  //     errors.push({
  //       field: 'serials',
  //       message: `Duplicate serial numbers found across different items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all items in this return.`
  //     });
  //   }

  //   return errors;
  // };

  // In SalesReturn component - Modified validation functions

  // ============================================
  // 🚀 COMPLETE TATMEEN VALIDATION FUNCTION (UPDATED)
  // ============================================
  const validateTatmeen = (itemsList, isTatmeenProduct, parentSsccCode) => {
    const errors = [];
    const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
      authInfo?.country === "United Arab Emirates" &&
      (authInfo?.subscription == 'PharmaERP_Pro' ||
        authInfo?.subscription == 'PharmaERP_Standard' ||
        authInfo?.subscription == 'PharmaERP_Basic');

    if (!isTatmeenUAE) {
      return { valid: true, errors: [] };
    }

    // ✅ Only consider items with return_quantity > 0
    const itemsWithReturn = itemsList.filter(
      item => Number(item.return_quantity || 0) > 0
    );

    // ✅ NEW: Separate items that have Tatmeen Required checked
    const tatmeenRequiredItems = itemsWithReturn.filter(
      item => item.is_tatmeen_required === true ||
        item.is_tatmeen_required === 1 ||
        item.is_tatmeen_required === "1"
    );

    const nonTatmeenItems = itemsWithReturn.filter(
      item => !(item.is_tatmeen_required === true ||
        item.is_tatmeen_required === 1 ||
        item.is_tatmeen_required === "1")
    );

    // ============================================
    // RULE 1: If Parent SSCC is given but Tatmeen is NOT enabled globally
    // ============================================
    const hasParentSSCC = parentSsccCode && parentSsccCode.trim() !== "";

    if (hasParentSSCC && !isTatmeenProduct) {
      errors.push({
        field: 'parent_sscc_code',
        message: 'Parent SSCC Code is provided but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes.'
      });
    }

    // ============================================
    // RULE 2: Check if any Tatmeen Required item has Child SSCC but Tatmeen not enabled
    // ============================================
    const hasTatmeenChildSSCC = tatmeenRequiredItems.some(
      item => item.child_sscc_code && item.child_sscc_code.trim() !== ""
    );

    if (hasTatmeenChildSSCC && !isTatmeenProduct) {
      const itemsWithChildSSCC = tatmeenRequiredItems
        .filter(item => item.child_sscc_code && item.child_sscc_code.trim() !== '')
        .map(item => item.product || item.item_name || 'Unknown Item')
        .join(', ');

      errors.push({
        field: 'child_sscc_code',
        message: `Child SSCC Codes are provided for Tatmeen Required items but Tatmeen is not enabled. Please enable Tatmeen to use SSCC codes. Items: ${itemsWithChildSSCC}`
      });
    }

    // ============================================
    // RULE 3: If Tatmeen is enabled globally - Parent SSCC is required
    // ============================================
    if (isTatmeenProduct && !hasParentSSCC) {
      errors.push({
        field: 'parent_sscc_code',
        message: 'Tatmeen is enabled but Parent SSCC Code is missing. Please enter the Parent SSCC Code.'
      });
    }

    // ============================================
    // RULE 4: Validate ONLY Tatmeen Required items
    // ============================================
    // 4a: Every Tatmeen Required item must have batch selected
    const itemsWithoutBatch = tatmeenRequiredItems.filter(
      item => !item.selected_batch_id
    );

    if (itemsWithoutBatch.length > 0) {
      const itemNames = itemsWithoutBatch
        .map(item => item.product || item.item_name || 'Unknown Item')
        .join(', ');

      errors.push({
        field: 'batch_id',
        message: `The following Tatmeen Required items are missing Batch selection:\n\n${itemNames}\n\nEach Tatmeen Required item must have a batch selected.`
      });
    }

    // 4b: Every Tatmeen Required item must have Child SSCC
    const itemsWithoutChildSSCC = tatmeenRequiredItems.filter(
      item => !item.child_sscc_code || item.child_sscc_code.trim() === ''
    );

    if (itemsWithoutChildSSCC.length > 0) {
      const itemNames = itemsWithoutChildSSCC
        .map(item => item.product || item.item_name || 'Unknown Item')
        .join(', ');

      errors.push({
        field: 'child_sscc_code',
        message: `The following Tatmeen Required items are missing Child SSCC Code:\n\n${itemNames}\n\nEach Tatmeen Required item must have a Child SSCC Code.`
      });
    }

    // 4c: Child SSCC validation with Parent (ONLY for Tatmeen Required items)
    if (tatmeenRequiredItems.length > 0) {
      const childSSCCs = tatmeenRequiredItems
        .map(item => item.child_sscc_code?.trim() || "")
        .filter(code => code !== "");

      if (childSSCCs.length > 0) {
        const distinctChildSSCCs = [...new Set(childSSCCs)];

        if (distinctChildSSCCs.length === 1) {
          const childSSCC = distinctChildSSCCs[0];
          if (parentSsccCode.trim() !== childSSCC) {
            errors.push({
              field: 'parent_sscc_code',
              message: `All Child SSCC Codes for Tatmeen Required items are "${childSSCC}" but Parent SSCC Code is "${parentSsccCode}".\n\nParent SSCC must match the Child SSCC when all are the same.`
            });
          }
        } else if (distinctChildSSCCs.length > 1) {
          if (distinctChildSSCCs.includes(parentSsccCode.trim())) {
            errors.push({
              field: 'parent_sscc_code',
              message: `Multiple distinct Child SSCC Codes found (${distinctChildSSCCs.join(', ')}).\n\nParent SSCC Code "${parentSsccCode}" matches one of the Child SSCC Codes, but it should be a different/unique code to group them all.\n\nParent SSCC must be different from all Child SSCC Codes when there are multiple distinct child codes.`
            });
          }
        }
      }
    }

    // ============================================
    // RULE 5: Serial validation ONLY for Tatmeen Required items
    // ============================================
    if (tatmeenRequiredItems.length > 0) {
      const serialErrors = validateSerialsForTatmeen(tatmeenRequiredItems);
      errors.push(...serialErrors);
    }

    return {
      valid: errors.length === 0,
      errors: errors
    };
  };

  // ============================================
  // 🚀 SERIAL VALIDATION FOR TATMEEN (UPDATED)
  // ============================================
  const validateSerialsForTatmeen = (tatmeenItems) => {
    const errors = [];
    const isTatmeenUAE = authInfo?.is_tatmeen_enabled === "yes" &&
      authInfo?.country === "United Arab Emirates";

    if (!isTatmeenUAE || !is_tatmeen_product) return errors;

    // Collect all serials for cross-item validation (only from Tatmeen Required items)
    const allSerials = [];
    const serialToItemMap = {};

    for (const row of tatmeenItems) {
      const serialMode = row.serial_mode || "unit";
      const returnQty = Number(row.return_quantity || 0);
      const selectedSerials = row.selectedSerials || [];
      const itemName = row.product || row.item_name || 'Unknown Item';

      // ============================================
      // UNIT MODE: Selected serials must match return quantity
      // ============================================
      if (serialMode === "unit") {
        if (selectedSerials.length !== returnQty) {
          errors.push({
            field: 'serials',
            item: itemName,
            message: `"${itemName}" requires ${returnQty} serial number${returnQty > 1 ? 's' : ''} but ${selectedSerials.length} selected.\n\nPlease select exactly ${returnQty} serial number${returnQty > 1 ? 's' : ''} for this item.`
          });
        }

        const duplicateWithinItem = selectedSerials.filter(
          (s, index) => selectedSerials.indexOf(s) !== index
        );

        if (duplicateWithinItem.length > 0) {
          errors.push({
            field: 'serials',
            item: itemName,
            message: `"${itemName}" contains duplicate serial numbers: ${duplicateWithinItem.join(', ')}.\n\nPlease remove duplicate serial numbers.`
          });
        }

        selectedSerials.forEach(serial => {
          if (serial && serial.trim()) {
            const trimmedSerial = serial.trim();
            allSerials.push(trimmedSerial);
            if (!serialToItemMap[trimmedSerial]) {
              serialToItemMap[trimmedSerial] = [];
            }
            serialToItemMap[trimmedSerial].push(itemName);
          }
        });
      }
      // ============================================
      // BATCH MODE: Exactly 1 serial required
      // ============================================
      else if (serialMode === "batch") {
        if (selectedSerials.length !== 1) {
          errors.push({
            field: 'serials',
            item: itemName,
            message: `"${itemName}" (Batch Mode) requires exactly 1 serial number but ${selectedSerials.length} selected.\n\nPlease select exactly 1 serial number for this batch item.`
          });
        }

        const availableQty = Number(row.available_qty || 0);
        if (returnQty !== 0 && returnQty !== availableQty) {
          errors.push({
            field: 'return_quantity',
            item: itemName,
            message: `"${itemName}" is in Batch Mode. Return quantity must be either 0 or ${availableQty}.`
          });
        }

        const serial = selectedSerials[0];
        if (serial && serial.trim()) {
          const trimmedSerial = serial.trim();
          allSerials.push(trimmedSerial);
          if (!serialToItemMap[trimmedSerial]) {
            serialToItemMap[trimmedSerial] = [];
          }
          serialToItemMap[trimmedSerial].push(itemName);
        }
      }
    }

    // ============================================
    // CROSS-ITEM SERIAL VALIDATION (Only for Tatmeen Required items)
    // ============================================
    const serialCount = {};
    allSerials.forEach(serial => {
      serialCount[serial] = (serialCount[serial] || 0) + 1;
    });

    const duplicateSerials = Object.keys(serialCount).filter(
      serial => serialCount[serial] > 1
    );

    if (duplicateSerials.length > 0) {
      const duplicateDetails = duplicateSerials.map(serial => {
        const items = serialToItemMap[serial] || [];
        const uniqueItems = [...new Set(items)];
        return `Serial "${serial}" appears in: ${uniqueItems.join(', ')}`;
      }).join('\n');

      errors.push({
        field: 'serials',
        message: `Duplicate serial numbers found across different Tatmeen Required items:\n\n${duplicateDetails}\n\nEach serial number must be unique across all Tatmeen Required items.`
      });
    }

    return errors;
  };

  const handleOnSaveSalesReturn = (
    customer,
    itemsList,
    footerValues,
    extraMasterData,
    selectedSerials,
    updatedServices
  ) => {


    const tatmeenValidation = validateTatmeen(
      itemsList,
      is_tatmeen_product,
      parent_sscc_code
    );

    if (!tatmeenValidation.valid) {
      // Format error messages for display
      const errorMessages = tatmeenValidation.errors.map((e, index) => {
        if (e.item) {
          return `${index + 1}. ${e.item}: ${e.message}`;
        }
        return `${index + 1}. ${e.message}`;
      }).join('\n\n');

      Swal.fire({
        icon: 'warning',
        title: 'Tatmeen Validation Failed',
        html: `
          <div style="text-align: left; max-height: 400px; overflow-y: auto;">
            <p style="font-weight: 600; margin-bottom: 12px;">Please fix the following issues:</p>
            <div style="background: #fff1f0; padding: 12px; border-radius: 6px; border: 1px solid #ffa39e;">
              ${errorMessages.replace(/\n/g, '<br>')}
            </div>
          </div>
        `,
        confirmButtonColor: '#1677ff',
      });
      return;
    }


    if (!itemsList?.length) {
      message.warning("Item cart is Empty!");
      return;
    }

    const hasValidReturnItem = itemsList.some(
      (item) => Number(item.return_quantity || 0) > 0
    );
    const payCart = Array.isArray(footerValues?.payCart)
      ? footerValues.payCart
      : [];

    const cartTotal = payCart.reduce(
      (sum, item) => sum + Number(item.tran_amount || 0),
      0
    );

    if (!hasValidReturnItem) {
      message.warning(
        "At least one item must have a return quantity greater than 0!"
      );
      return;
    }

    if (!extraMasterData.sales_return_acc_id) {
      message.warning("Select Sales Return Account!");
      return;
    }
    if (!extraMasterData.discount_acc_id) {
      message.warning("Discount Account is Required!");
      return;
    }
    if (!extraMasterData.tax_acc_id) {
      message.warning("VAT Account is Required!");
      return;
    }
    if (!customer) {
      message.warning("Select customer!");
      return;
    }
    if (!extraMasterData.created_date) {
      message.warning("Entry Date is Required!");
      return;
    }

    const paid = Number(footerValues?.paidAmount || 0);
    const total = Number(footerValues?.totalAmount || 0);

    // if (cartTotal !== total) {
    //   message.warning("Paid Amount and Grand Total must be the same!");
    //   return;
    // }

    // if (paid === 0 && total === 0) {
    //   message.warning("Paid Amount and Grand Total must not be empty!");
    //   return;
    // }
    //     if (cartTotal > 0 && Math.abs(cartTotal - total) > 0.01) {
    //   message.warning("Payment amount should match Grand Total!");
    //   return;
    // }

    // if (cartTotal > total + 0.01) {
    //   message.warning("Payment amount exceeds Grand Total!");
    //   return;
    // }

    // if (total <= 0) {
    //   message.warning("Grand Total must be greater than 0!");
    //   return;
    // }

    const invalidRows = itemsList.filter((item) => {

      const isTatmeenRequired = item.is_tatmeen_required === true ||
        item.is_tatmeen_required === 1 ||
        item.is_tatmeen_required === "1";

      // Skip validation for non-Tatmeen items
      if (!isTatmeenRequired) {
        return false;
      }
      if (item.serial_mode === "batch") {
        const qty = Number(item.return_quantity || 0);

        // No return -> valid
        if (qty === 0) {
          return false;
        }

        // Must return full quantity
        if (qty !== Number(item.available_qty)) {
          return true;
        }

        // Must select exactly one batch serial
        return (item.selectedSerials || []).length !== 1;
      }

      if (item.serial_mode === "unit") {
        return (
          Number(item.return_quantity || 0) !==
          (item.selectedSerials || []).length
        );
      }

      return false;
    });

    if (invalidRows?.length > 0 && is_tatmeen_product) {
      message.warning(
        "Unit items require the selected serial count to match the return quantity ."
      );
      // Swal.fire({
      //   icon: "warning",
      //   title:
      //     "Batch items must either have a return quantity of 0 or be returned completely with exactly one batch serial selected. Unit items require the selected serial count to match the return quantity.",
      //   confirmButtonColor: "#1677ff",
      // });
      return;
    }
    const payload = createSalesReturnPayload(
      customer,
      itemsList,
      footerValues,
      extraMasterData,
      selectedSerials,
      updatedServices,

    );


    const action = sale_r_id
      ? updateSalesReturn({ ...payload, sale_r_id })
      : createSalesReturn(payload);

    dispatch(action)
      .unwrap()
      .then((res) => {
        Swal.close();
        if (!res.error) {
          dispatch(resetFormData());
          dispatch(resetSalesReturnState());
          Swal.fire({
            title: sale_r_id ? "Sales Return Updated! Do you want to view voucher?"
              : "Sales Return Created! Do you want to view voucher?",
            icon: "success",
            showCancelButton: true,
            confirmButtonText: "Yes, view voucher",
            cancelButtonText: "No, back",
          }).then((result) => {
            if (result.isConfirmed) {
              navigate(`/sales/quick-sales-return-voucher/${res.sale_r_id}`);
            } else {
              dispatch(resetFormData());
              window.location.reload();
              navigate("/sales-return", { replace: true });
            }
          });
        } else {
          Swal.fire(res.message || "Something went wrong", "", "warning");
        }
      })
      .catch(() => {
        Swal.close();
        Swal.fire("Network ERROR", "", "error");
      });
  };

  useEffect(() => {
    return () => dispatch(resetSalesReturnState());
  }, []);

  useEffect(() => {
    if (!sale_r_id) {
      dispatch(fetchSalesReturnVoucher());
    }
    dispatch(fetchSalesReturnAccounts()).then((res) => {
      if (res.payload?.length) {
        // ✅ Auto-select first account that contains "sales return" or just first
        const defaultAcc =
          res.payload.find(a => a.acc_name?.toLowerCase().includes("sales return"))
          || res.payload[0];
        dispatch(setFormField({ field: "selectedSalesReturnAcc", value: defaultAcc }));
      }
    });
    dispatch(fetchDiscountAccounts());
    dispatch(fetchTaxAccounts());
    dispatch(fetchTransportAccounts());
  }, [dispatch]);
  useEffect(() => {
    if (selectedRecord?.cheque_status === "approved") {
      message.warning("Cheque processed. Editing not allowed.");
      navigate("/sales-return");
    }
  }, [selectedRecord]);

  useEffect(() => {
    if (sale_r_id) {
      dispatch(setIsEditSalesReturn(true));
      dispatch(fetchSalesReturnWithDetails(sale_r_id));
    }
  }, [sale_r_id, dispatch]);

  useEffect(() => {
    if (salesReturnSuccess?.message) {
      // modal.success({ title: salesReturnSuccess.message });
      dispatch(resetSalesReturnStatus());
    }
  }, [salesReturnSuccess, modal, dispatch]);

  return (
    <CreateSalesReturnForm
      onSaveSalesReturn={handleOnSaveSalesReturn}
      salesVouchers={vouchersList}
      salesReturnVoucher={salesReturnVoucher}
      selectedVoucherDetails={selectedVoucherDetails}
      salesReturnAccs={salesReturnAccounts}
      salesTaxAccs={salesTaxAccounts}
      salesDiscountAccs={salesDiscountAccounts}
      salesTransportAccs={salesTransportAccounts}
    />
  );
};

export default SalesReturn;
